import { statusVariant } from "../utils/status.js";

export default function StatusChip({ status }) {
  if (!status) return null;
  return <span className={`status-chip status-${statusVariant(status)}`}>{status}</span>;
}
